import { store } from '../../src/store';
import { APP_SETTINGS } from "../config/config";
import { ILabInventory } from '../pages/lab-inventory/type';

// Method that check whether user is having permission to see Action or menuitem
export const checkForPermission = (
    type: 'Action' | 'MenuItem',
    name: string | undefined
) => {
    const storeData = store.getState();
    const userDetails = storeData.auth.userDetails;
    let currentUserRoles: Array<string> = [];
    if (
        userDetails &&
        userDetails.permissionRoles &&
        userDetails.permissionRoles.length > 0
    ) {
        currentUserRoles = [...userDetails.permissionRoles];
    } else {
        // Added below condition to solve issue on reload of the page
        // If not added, user will directly get access denied page while user detail fetch process is in progress
        if (
            userDetails.name === '' &&
            userDetails.permissionRoles.length === 0
        ) {
            currentUserRoles = ['LabEngRO'];
        } else {
            currentUserRoles = [];
        }
    }
    // Retrieve the assiged roles for different type
    let requestedRoles: Array<string> = [];

    if (type === "Action" && name !== "" && name !== undefined) {
        requestedRoles = APP_SETTINGS.ACTION_PERMISSION[name] || [];
    }
    else if (type === "MenuItem" && name !== "" && name !== undefined) {
        requestedRoles = APP_SETTINGS.MENU_ITEM_PERMISSION[name];
    }

    let userHasPermission = false;
    if (requestedRoles) {
        for (const role of requestedRoles) {
            if (currentUserRoles.indexOf(role) !== -1) {
                userHasPermission = true;
                break;
            }
        }
    }

    if (userHasPermission) {
        return true;
    } else {
        return false;
    }
};

// Method to check if there is any change in permission level
// If change is there then remove some settings from the local storage
export const checkForPermissionChange = (curentPermission: Array<string>) => {
    const cachedPermissionDetails = JSON.parse(
        localStorage.getItem('permission') || '{}'
    );
    let isChange = false;
    if (cachedPermissionDetails.length === curentPermission.length) {
        for (const permission of cachedPermissionDetails) {
            if (curentPermission.indexOf(permission) === -1) {
                isChange = true;
                break;
            }
        }
    } else {
        isChange = true;
    }
    if (isChange) {
        localStorage.removeItem('selectedColumns');
        localStorage.setItem('permission', JSON.stringify(curentPermission));
    }
};


export const canLeaseItem = (
    userDetails: any,
    item: ILabInventory,
    checkIfSgnameExists: (sgname: string) => boolean
) => {
    const roles = userDetails?.permissionRoles || [];
    const isSooperOrManager = roles.includes("SooperTrooper") || roles.includes("LabManager");
    const isRW = roles.includes("LabEngRW");
    const isRO = roles.includes("LabEngRO");

    if (isSooperOrManager) {
        return { canLease: true, canCheckout: true, canOtherActions: true };
    }

    if (item.isManagerApproval) {
        return { canLease: false, canCheckout: false, canOtherActions: false };
    }

    if (item.isTented) {
        if (isRW && checkIfSgnameExists(item.tentedSecurityGroup)) {
            return { canLease: true, canCheckout: true, canOtherActions: true };
        }
        return { canLease: false, canCheckout: false, canOtherActions: false };
    }
    if (isRW) {
        const leaseOwner = item.ecaasleases?.[0]?.user?.alias ?? "";
        const currentUser = userDetails?.alias ?? userDetails?.userName?.split("@")[0] ?? "";
        const isOwner = leaseOwner === currentUser;

        return {
            canLease: true,
            canCheckout: true,
            canOtherActions: isOwner,
        };
    }


    if (isRO) {
        return { canLease: false, canCheckout: false, canOtherActions: false };
    }

    return { canLease: false, canCheckout: false, canOtherActions: false };
};

